const STRIPE_API_KEY = 'pk_live_a17xWj2TvFEdi5fy9PogE70r';

export default Object.freeze({
    STRIPE_API_KEY: STRIPE_API_KEY    
});